import { render, staticRenderFns } from "./satelliteEventCard.html?vue&type=template&id=f2594566&scoped=true&external"
import script from "./satelliteEventCard.vue?vue&type=script&lang=ts"
export * from "./satelliteEventCard.vue?vue&type=script&lang=ts"
import style0 from "./satelliteEventCard.scss?vue&type=style&index=0&id=f2594566&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2594566",
  null
  
)

export default component.exports